import React from 'react';
import AgentDashboard from './AgentDashboard';

const ServiceDeskDashboard: React.FC = () => {
  const agentConfig = {
    id: 'service-desk',
    displayName: 'Service Desk',
    icon: '/assets/logos/aldo-service-desk.png',
    color: '#d946ef',
    description: 'IT Service Desk support assistant',
    hasTestResults: false
  };

  return <AgentDashboard agentConfig={agentConfig} />;
};

export default ServiceDeskDashboard;

